export function formatCount(num?: number): string {
  if (num === undefined || num === null) return '';

  if (num >= 1_000_000) {
    const value = Math.floor((num / 1_000_000) * 10) / 10;
    return `${value}M`;
  }

  if (num >= 1_000) {
    const value = Math.floor((num / 1_000) * 10) / 10;
    return `${value}K`;
  }

  return String(num);
}
